import { FlexRow } from '@/components/common/Flex';
import { InfoCircle } from '@/components/common/icons';
import { Paragraph } from '@/components/common/Typography';
import FinancialEntityRelinkButton from '@/components/financialEntities/FinancialEntityRelinkButton';
import { Box, BoxProps, Heading } from '@chakra-ui/react';
import { ExternalFinancialEntity } from '@common/financialEntities';

export interface FinancialEntityRelinkSectionProps extends BoxProps {
    account: ExternalFinancialEntity;
    isFundingAccount: boolean;
}

const FinancialEntityRelinkSection = ({
    account,
    isFundingAccount,
    ...props
}: FinancialEntityRelinkSectionProps) => {
    if (!account.isMine) return null;

    return (
        <Box {...props}>
            <Heading mb={3} fontSize="md" fontWeight={500}>
                <FlexRow align="center">
                    <InfoCircle mr={3} />
                    {isFundingAccount
                        ? `Reconnect your funding account`
                        : `Reconnect your account`}
                </FlexRow>
            </Heading>
            <Paragraph color="textMuted" mb={4}>
                {isFundingAccount
                    ? `Keep your funding account connected to make sure we have up-to-date account information and your next scheduled transfer is successful.`
                    : `Keep your account connected to make sure we have up-to-date account information.`}
            </Paragraph>
            <FinancialEntityRelinkButton account={account} title="Reconnect" />
        </Box>
    );
};

export default FinancialEntityRelinkSection;
